import { render, staticRenderFns } from "./RulesOfRegulation.vue?vue&type=template&id=4c2a9ec2&"
import script from "./RulesOfRegulation.vue?vue&type=script&lang=js&"
export * from "./RulesOfRegulation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMain } from 'vuetify/lib/components/VMain';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VMain,VOverlay})
